import React from 'react';
import { UserIcon } from 'assets/icons';
import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import moment from 'moment';
import { Constants, Globals } from 'utils';
import { HomeService } from 'services';
import { connect } from 'react-redux';

const chartLocales = {
  defaultLocale: 'es',
  locales: [
    {
      name: 'es',
      options: {
        months: [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre',
        ],
        shortMonths: [
          'Ene',
          'Feb',
          'Mar',
          'Abr',
          'May',
          'Jun',
          'Jul',
          'Ago',
          'Sep',
          'Oct',
          'Nov',
          'Dic',
        ],
        days: [
          'Lunes',
          'Martes',
          'Miércoles',
          'Jueves',
          'Viernes',
          'Sábado',
          'Domingo',
        ],
        shortDays: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
      },
    },
  ],
};

class Home extends React.Component<any> {
  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Inicio',
        onBack: null,
      },
    });

    console.log('hola?');
  }

  render() {
    return (
      <section id="admin-home">
        <Profit />
        <UsersRegisters />
        <Memberships />
        <Documents />
      </section>
    );
  }
}

const UsersRegisters = () => {
  const [state, setState] = useState<any>({
    series: [],
    options: {
      legend: {
        show: false,
      },
      chart: {
        type: 'donut',
      },
      colors: ['#7f00b2', '#77dd77', '#19B6D1'],
      labels: ['Abogados', 'Clientes'],
      dataLabels: {
        enabled: false,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 100,
            },
            legend: {
              show: false,
            },
          },
        },
      ],
    },
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const res: any = await HomeService.admin.getUsers();
    setState({
      ...state,
      series: [res?.lawyers || 0, res?.clients || 0],
    });
  };

  return (
    <div className="register-users">
      <div className="card">
        <h3 className="background-title">
          Número de usuarios registrados últimos 30 días
        </h3>
        <div className="body">
          {state.series.length > 0 ? (
            <>
              <div className="chart">
                <ReactApexChart
                  options={state.options}
                  series={state.series}
                  type="donut"
                />
              </div>
              <ul>
                <div>
                  <li className="purple">Abogados</li>
                  <p className="percentage">%{state.series[0]}</p>
                </div>
                <div>
                  <li className="green">Clientes</li>
                  <p className="percentage">%{state.series[1]}</p>
                </div>
              </ul>
            </>
          ) : (
            <p className="empty-message">No hay usuarios registrados</p>
          )}
        </div>
      </div>
    </div>
  );
};

const Profit = () => {
  const [state, setState] = useState<any>({
    series: [],
    options: {
      chart: {
        ...chartLocales,
        height: 350,
        parentHeightOffset: 0,
        type: 'line',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        pan: {
          enabled: false,
        },
      },
      colors: [
        '#19b6d1',
        '#779a0a',
        '#40005a',
        '#7f00b2',
        '#d20b06',
        '#FFC107',
        '#46fca5',
        '#0E2954',
        '#099896',
      ],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'straight',
      },
      xaxis: {
        type: 'datetime',
        labels: {
          format: 'dd MMM',
        },
      },
    },
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const res: any = await HomeService.admin.getProfit();

    const seriesData = res.map((item: any) => {
      return {
        name: item.name,
        data: item.data.map((i: any) => ({
          x: i.created_at,
          y: parseFloat(i?.total?.toFixed(2)),
        })),
      };
    });

    console.log(seriesData);

    const maxQuantity = Math.max(
      ...seriesData.map((i: any) =>
        i.data
          .map((j: any) => j.y)
          .reduce((acc: any, item: any) => acc + item, 0),
      ),
    );

    setState({
      ...state,
      series: seriesData,
      options: {
        ...state.options,
        xaxis: {
          ...state.options.xaxis,
          //min: startOfMonth.valueOf(),
        },
        yaxis: {
          ...state.options.yaxis,
          max: maxQuantity,
        },
      },
    });
  };

  return (
    <div className="profit">
      <div className="card">
        <h3 className="background-title">Ingresos generados últimos 30 días</h3>
        <div className="overflow">
          {state.series.length > 0 ? (
            <ReactApexChart
              options={state.options}
              series={state.series}
              type="line"
              height={270}
            />
          ) : (
            <p className="empty-message">No hay ganancias registradas</p>
          )}
        </div>
      </div>
    </div>
  );
};

const Documents = () => {
  const colorPalette = [
    { fill: '#7f00b2', stroke: '#5a007f' },
    { fill: '#77dd77', stroke: '#4caf50' },
    { fill: '#19B6D1', stroke: '#128fa3' },
    { fill: '#f39c12', stroke: '#d98200' },
    { fill: '#e74c3c', stroke: '#c0392b' },
    { fill: '#3498db', stroke: '#2980b9' },
    { fill: '#9b59b6', stroke: '#8e44ad' },
  ];

  const [state, setState] = useState<any>({
    series: [],
    options: {
      plotOptions: {
        bar: {
          borderRadius: 10,
        },
      },
      chart: {
        height: 270,
        type: 'bar',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        pan: {
          enabled: false,
        },
      },
      colors: ['#7f00b2', '#77dd77', '#19B6D1', '#f39c12', '#e74c3c'],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'straight',
      },
      yaxis: {
        labels: {
          formatter: function (value: any) {
            return Math.round(value);
          },
        },
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            fontSize: '12px',
          },
        },
      },
    },
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const res: any = await HomeService.admin.getDocumentsGenerated();

    const entries = Object.values(res) as any[];

    const seriesData = entries.map((item: any, index: number) => {
      const initials = Globals.getInitials(item.name);
      const color = colorPalette[index % colorPalette.length];
      return {
        x: initials,
        y: item.quantity,
        name: item.name,
        fillColor: color.fill,
        strokeColor: color.stroke,
      };
    });

    setState({
      series: [
        {
          name: 'Total',
          data: seriesData,
        },
      ],
      options: {
        ...state.options,
        xaxis: {
          ...state.options.xaxis,
        },
        legend: {
          ...state.options.legend,
          labels: {
            colors: undefined,
            useSeriesColors: true,
          },
        },
      },
    });
  };

  return (
    <div className="documents">
      <div className="card">
        <div className="header-title">
          <h3 className="background-title">
            Tipos de documentos generados últimos 30 días
          </h3>
        </div>
        <div className="body">
          {state.series.length > 0 ? (
            <>
              <ReactApexChart
                options={state.options}
                series={state.series}
                type="bar"
                height={270}
              />
              <ul className="legend">
                {state.series[0].data.map((item: any, index: number) => (
                  <li
                    key={index}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <span
                      style={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: item.fillColor,
                        marginRight: '5px',
                      }}
                    ></span>
                    {`${item.name} (${item.x})`}
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <p className="empty-message">No hay documentos registrados</p>
          )}
        </div>
      </div>
    </div>
  );
};

const monthOptions = moment.months().map((month, index) => ({
  value: `${index + 1}`,
  label: month,
}));

const levelNames: Record<number, string> = {
  [Constants.LEVELS.CLIENT]: 'Cliente',
  [Constants.LEVELS.LAWYER]: 'Abogado',
};

const Memberships = () => {
  const [selectedMonth, setSelectedMonth] = useState(moment().month() + 1);
  const [state, setState] = useState<any>({
    series: [],
    options: {
      chart: { type: 'donut' },
      colors: ['#7f00b2', '#77dd77', '#19B6D1', '#f39c12', '#e74c3c'],
      labels: [],
      dataLabels: { enabled: false },
      legend: { show: false },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: { width: 100 },
            legend: { show: false },
          },
        },
      ],
    },
  });

  const [customLegend, setCustomLegend] = useState<any>({});

  useEffect(() => {
    getData();
  }, [selectedMonth]);

  const getData = async () => {
    const res: any = await HomeService.admin.getMemberships();

    const grouped: Record<
      number,
      { label: string; value: number; color: string }[]
    > = {};
    const flatSeries: number[] = [];
    const flatLabels: string[] = [];
    const flatColors: string[] = [];

    let colorIndex = 0;

    res.forEach((item: any) => {
      const level = item.membership.level_id;
      const label = item.membership.name;
      const value = parseFloat(item.percentage);
      const color =
        state.options.colors[colorIndex % state.options.colors.length];

      if (!grouped[level]) grouped[level] = [];
      grouped[level].push({ label, value, color });

      flatSeries.push(value);
      flatLabels.push(label);
      flatColors.push(color);

      colorIndex++;
    });

    setCustomLegend(grouped);

    setState((prev: any) => ({
      ...prev,
      series: flatSeries,
      options: {
        ...prev.options,
        labels: flatLabels,
        colors: flatColors,
      },
    }));
  };

  return (
    <div className="memberships">
      <div className="card">
        <h3 className="background-title">
          Registro de membresía último 30 días
        </h3>
        {state.series.length > 0 ? (
          <div className="body">
            <ReactApexChart
              options={state.options}
              series={state.series}
              type="donut"
              height={270}
            />
            <div className="custom-legend">
              {Object.entries(customLegend).map(([levelId, items]: any) => (
                <div key={levelId}>
                  <p>{levelNames[parseInt(levelId)]}</p>
                  <ul>
                    {items.map((item: any, index: any) => (
                      <li key={index}>
                        <span
                          style={{
                            display: 'inline-block',
                            width: 12,
                            height: 12,
                            backgroundColor: item.color,
                            borderRadius: '50%',
                            textTransform: 'capitalize',
                          }}
                        ></span>
                        {item.label} - {item.value}%
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p className="empty-message">
            No hay planes adquiridos para este mes
          </p>
        )}
      </div>
    </div>
  );
};

export default connect()(Home);
